export const STATS = {
    SHELL: {},
    ADMIN: {},
    MAP: {
        CREATE: "map_create",
        OPEN: "map_open",
        NODE_CREATE: "map_node_create",
        EDGE_CREATE: "map_edge_create",
        TABLE_CREATE: "map_table_create",
        IMAGE_INSERT: "map_image_insert",
        VIDEO_INSERT: "map_video_insert",
        LINK_INSERT: "map_link_insert",
        DOCUMENT: "map_document",
        PRINT: "map_print",
        SHARE_INTERNAL: "map_share_internal",
        SHARE_CLASSROOM: "map_share_classroom",
        SHARED_VIEW: "map_shared_view",
        SHARED_COPY: "map_shared_copy"
    },
    EDITOR: {
        CREATE: "edt_create",
        OPEN: "edt_open",
        PRINT: "edt_print",
        SHARE_INTERNAL: "edt_share_internal",
        SHARE_CLASSROOM: "edt_share_classroom",
        SHARED_VIEW: "edt_shared_view",
        SHARED_COPY: "edt_shared_copy"
    },
    PDF: {
        OPEN: "pdf_open",
        PRINT: "pdf_print",
        SHARE_INTERNAL: "pdf_share_internal",
        SHARE_CLASSROOM: "pdf_share_classroom",
        SHARED_VIEW: "pdf_shared_view",
        SHARED_COPY: "pdf_shared_copy"
    },
    MATH: {
        OCR: "mth_ocr",
        INSERT_IN_DOC: "mth_insert_in_doc",
        OCR_IN_EDITOR: "mth_ocr_in_editor",
        AI_CHECK: "mth_ai_check"
    }
}